@let hasValue = value().length > 0;
@let editLabel = 'filters.pill.edit' | translate: { field: label() };

<div
  class="f-chip"
  [class.is-empty]="requiresValue() && !hasValue"
  [class.is-active]="active()">
  <!-- One hover target: all three segments open the same parameter dropdown. -->
  <div class="chip-open">
    <button
      type="button"
      class="seg col"
      [attr.aria-label]="editLabel"
      (click)="clickOnPill.emit()">
      <i [class]="typeIcon()"></i>
      <span>{{ label() }}</span>
    </button>

    <button
      type="button"
      class="seg op"
      [attr.aria-label]="editLabel"
      (click)="clickOnPill.emit()">
      <span>{{ operationLabel() }}</span>
      <i [class]="ICONS.caretDown" class="caret" [class.rotate-180]="active()"></i>
    </button>

    @if (requiresValue()) {
      <button
        type="button"
        class="seg val"
        [attr.aria-label]="editLabel"
        (click)="clickOnPill.emit()">
        @if (hasValue) {
          <span>{{ value() }}</span>
        } @else {
          <span class="ph">{{ 'filters.pill.choose_value' | translate }}</span>
        }
      </button>
    }
  </div>

  <button
    type="button"
    class="seg rm"
    [attr.title]="'filters.pill.remove' | translate: { field: label() }"
    [attr.aria-label]="'filters.pill.remove' | translate: { field: label() }"
    (click)="removeFilter.emit()">
    <i [class]="ICONS.x"></i>
  </button>
</div>
